module.exports = __webpack_public_path__ + "static/media/pinkslip.svg?v=eb2ddfb4";